<template>
  <div class="finance-detail-page page-padding-top">
    <top-bar :title="i18n.t(`financeBuy.title`)" @back="back" ></top-bar>

    <div class="info-box ">
      <div class="flex-1 flex-center-between">
        <div class="label">{{i18n.t('financeBuy.label1')}}</div>
        <div class="label">{{i18n.t('financeBuy.label2')}}</div>
      </div>
      <div class="flex-1 flex-center-between">
        <div class="count">{{detailData.IncomeRatio}}%</div>
        <div class="count">{{detailData.ProductType == 1 ? i18n.t('financeBuy.label2_1') : `${detailData.Term}${$t('financeBuy.label13')}`}}</div>
      </div>
    </div>

    <div class="finance-detail">
      <div class="detail-title">{{i18n.t('financeBuy.label3')}}</div>
      <div class="input flex-center-between">
        <input type="number" inputmode="decimal" v-model="form.number" :placeholder="i18n.t('financeBuy.placeholder')">
        <div class="flex-center adot">
          <span>USDT</span>
          <span class="input-btn" @click="setAll">{{i18n.t('financeBuy.label4')}}</span>
        </div>
      </div>

      <div class="detail-line flex-center-start">
        <div class="label">{{i18n.t('financeBuy.label5')}}</div>
        <div class="value">{{parseFloat(userMoney).toFixed(4)}}USDT</div>
        <div class="money-btn" @click="toPath('transfer', {type: 5})">{{$t('financeBuy.label6')}}</div>
      </div>
      <div class="detail-line flex-center-between">
        <div class="label">{{i18n.t('financeBuy.label7')}}</div>
        <div class="value">{{parseFloat(detailData.MinimumBet).toFixed(4)}}</div>
      </div>


      <div class="detail-title mt-24">{{$t('financeBuy.label8')}}</div>

      <div class="warning flex-start">
        <div>
          <span>{{i18n.t('financeBuy.desc1')}}</span>
          <span> {{moment().add(1, 'days').format('YYYY-MM-DD')}} </span>
          <span>{{i18n.t('financeBuy.desc2')}}</span>
        </div>
      </div>

      <div class="detail-line flex-center-between before">
        <div class="label">{{i18n.t('financeBuy.label9')}}</div>
        <div class="value">{{moment().format('YYYY-MM-DD')}}</div>
      </div>
      <div class="detail-line flex-center-between before line">
        <div class="label">{{i18n.t('financeBuy.label10')}}</div>
        <div class="value">{{moment().add(1, 'days').format('YYYY-MM-DD')}}</div>
      </div>
      <div class="detail-line flex-center-between before line">
        <div class="label">{{i18n.t('financeBuy.label11')}}</div>
        <div class="value ">{{i18n.t('financeBuy.label12')}}</div>
      </div>
    </div>


    <div class="bottom-btn clear">
      <div class="flex-center-start role" @click="changeRole">
        <Checkbox v-model="isCheck" icon-size="16px">
          <span>{{i18n.t('financeBuy.role')}}</span>
          <span class="blue" @click.stop="showRole">{{i18n.t('financeBuy.role2')}}</span>
        </Checkbox>
      </div>
      <Button :disabled="!isCheck" @click="submit">{{i18n.t('financeBuy.btn')}}</Button>
    </div>

    <role-page :roleData="agreementData" v-show="showRoleModal" @cancel="cancel"></role-page>
  </div>
</template>
<script>
import { Button, Form, List, Checkbox } from 'vant'
import rolePage from './role'
import moment from 'moment'
import topBar from '@/components/topBar'
import { financeBuy } from '@/api/finance'
import { wallet } from '@/api/assest'
import TokenWebView from '@consenlabs-fe/webview'
export default {
  components: {
    Button,
    List,
    Checkbox,
    rolePage,
    topBar
  },
  data() {
    return {
      form: {
        number: ''
      },
      userMoney: 0,
      backUrl: require('../../assets/imgs/icon-back.png'),
      warningUrl: require('../../assets/imgs/icon-warning.png'),
      checkUrl: require('../../assets/imgs/icon-checked.png'),
      checkUrl2: require('../../assets/imgs/icon-uncheck.png'),
      detailData: {
        Currency: {}
      },
      isCheck: false,
      agreementData: {},
      showRoleModal: false
    }
  },
  mounted() {
    this.detailData = JSON.parse(sessionStorage.getItem('financeData'))
    this.init()
    // this.initAgreement()
  },
  methods: {
    moment,
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query: query || {}
        })
      }
    },
    init() {
      let form = new FormData()
      form.append('ShortName', 'usdt')
      form.append('current', 1)
      form.append('pageSize', 10)
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.userMoney = parseFloat(data.FinanceUse)
        }
      })
    },
    initAgreement() {
      let form = new FormData()
      form.append('financial_setup_id', this.detailData.ID)
      agreementList(form).then(res => {
        this.agreementData = res.data.Items[0]
      })
    },
    back() {
      this.$router.go(-1)
    },
    changeRole() {
      this.isCheck = !this.isCheck
    },
    setAll() {
      this.form.number = this.userMoney
    },
    submit() {
      if (!this.form.number) {
        this.$toast.fail(this.i18n.t('financeBuy.placeholder'))
        return
      }
      let form = new FormData()
      form.append('Amount', this.form.number)
      form.append('FinancialSetupId', this.detailData.ID)
      financeBuy(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.i18n.t('financeBuy.success'))
          setTimeout(() => {
            this.back()
          }, 1500)
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    showRole() {
      this.$router.push({
        name: 'financeRole'
      })
    },
    cancel() {
      this.showRoleModal = false
    }
  }
}
</script>